import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';

import {
  CreateManyPlansModal,
  SavePlanSetModal
} from 'modules/components/layer17';

import { ActivityHeaderSectionWithMetricsLayout } from 'modules/components/layer32';

import * as ds from './dataService';

export type PlanSetHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanSetHeaderSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.planSetId ?? '');
  return (
    <ActivityHeaderSectionWithMetricsLayout.FC
      title={data.displayName}
      subtitle='Plan Set'
      metrics={<></>}
      actionButtons={(
        <ActionButtonsGroup />
      )}
    />

  );
};

type ActionButtonsGroupProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState<boolean>(false);
  const [
    isAddPlansVisible,
    setIsAddPlansVisible
  ] = useState<boolean>(false);
  const params = useParams();
  return (
    <>
      {
        isVisible && (
          <SavePlanSetModal.FC
            id={params.planSetId ?? ''}
            isVisible={isVisible}
            handleClose={() => setIsVisible(() => false)}
          />
        )
      }
      {
        isAddPlansVisible && (
          <CreateManyPlansModal.FC
            id={params.planSetId ?? ''}
            isVisible={isAddPlansVisible}
            handleClose={() => setIsAddPlansVisible(() => false)}
          />
        )
      }
      <Button
        variant='contained'
        onClick={() => {
          setIsVisible(() => true);
        }}
      >
        Edit Plan Set Name
      </Button>
      <Button
        variant='contained'
        onClick={() => {
          setIsAddPlansVisible(() => true);
        }}
      >
        Add Plans
      </Button>
    </>

  );
};
